import React from 'react';
import get from 'lodash/get';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../CommonComponents/OPL/Select/Select/Select';
import { OptionType } from '../../CommonComponents/OPL/Select/BaseSelect/types';
import { EarmarkValueDTO } from '../ManageExcessCashModal.meta';

interface Props {
  formKey?: string;
  earmarkOptions: OptionType<EarmarkValueDTO>[];
}

export const GoalEarmark = ({ formKey = 'ExcessCashGoalEarmark', earmarkOptions }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const allGoalsOption = earmarkOptions.filter(goal => goal.label === 'All Goals');
  const error = get(errors, formKey);

  return (
    <Controller
      control={control}
      name={formKey}
      render={({ field: { value, onChange } }) => {
        const isAllGoalsSelected = earmarkOptions
          .filter(opt =>
            value?.some(
              v =>
                v.earmarkType === opt.value.earmarkType &&
                v.dependent?.id === opt.value.dependent?.id &&
                v.name === opt.value.name,
            ),
          )
          ?.some(v => v.label === 'All Goals');

        const options = isAllGoalsSelected ? allGoalsOption : earmarkOptions;

        return (
          <Select
            isMulti
            isPortal
            options={options}
            value={options.filter(opt =>
              value?.some(
                v =>
                  v.earmarkType === opt.value.earmarkType &&
                  v.dependent?.id === opt.value.dependent?.id &&
                  v.name === opt.value.name,
              ),
            )}
            onChange={opts => onChange(opts.map(opt => opt.value))}
            label="Excess Cash Goal Earmark"
            tooltip="Please select the goal(s) you will fund with the saved excess cash."
            closeMenuOnSelect={false}
            formVariant={error && 'error'}
            helperText={error?.message}
          />
        );
      }}
    />
  );
};
